import React from 'react';
import classes from "./ChartDiv.module.css";
import chart1 from "../../../assets/Game/bars/chart1.png";
import chart2 from "../../../assets/Game/bars/chart2.png";
import chart3 from "../../../assets/Game/bars/chart3.png";
import bArrow from "../../../assets/Game/chartbtn/back-arr.png";
import fArrow from "../../../assets/Game/chartbtn/forward-arr.png";


interface chartDivProps {
    nextClick: () => void;
    prevClick: () => void;
    spaceKitty: any;
    total: number
}

const ChartDiv:React.FC<chartDivProps> = ({spaceKitty, nextClick, prevClick, total}) => {    

  let chartImg = chart1

    return (
        <div className={classes["battle-chart-div"]}>
            <div>
                <img src={spaceKitty.imageUrl} alt="Mesh NFT" />
            </div>
            <div>
                <img src={chartImg} alt="Chart" />
            </div>
            <div className={classes["battle-rating-control"]}>
                {total > 1 && <div className={classes["arrow-img"]} >
                    <span  onClick={() => {
                        prevClick()
                    }}>
                        <img  src={bArrow} alt="arrow btn" />
                    </span>
                    <span onClick={() => {
                        nextClick()
                    }}>
                        <img src={fArrow} alt="arrow btn" />
                    </span>
                </div>}
            </div>
        </div>
    );
}

export default ChartDiv